import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button, Input, Label } from "@/components/kit";
import { api, apiErr } from "@/lib/api";
import { HardHat, ArrowRight } from "lucide-react";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await login(email, password);
      toast.success("Inloggad");
      nav("/");
    } catch (err) {
      toast.error(apiErr(err, "Inloggning misslyckades"));
    } finally {
      setBusy(false);
    }
  };

  const forgot = async () => {
    const em = window.prompt("Ange din e-post så skickar vi en återställningslänk:", email);
    if (!em) return;
    try {
      await api.post("/auth/forgot-password", { email: em });
      toast.success("Om adressen finns skickar vi en återställningslänk via e-post.");
    } catch (err) {
      toast.error(apiErr(err));
    }
  };

  return (
    <div className="relative flex min-h-screen items-center justify-center overflow-hidden bg-slate-950 px-4">
      <div
        className="absolute inset-0 opacity-25"
        style={{
          backgroundImage:
            "url('https://images.unsplash.com/photo-1580901368813-93220b510345?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600')",
          backgroundSize: "cover", backgroundPosition: "center",
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-t from-slate-950 via-slate-950/80 to-slate-950/40" />
      <div className="relative z-10 w-full max-w-md rise">
        <div className="mb-8 flex items-center gap-3">
          <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-amber-500 text-slate-950">
            <HardHat size={26} />
          </div>
          <div>
            <div className="font-display text-xl font-extrabold text-white">TJ Entreprenadkonsult</div>
            <div className="text-xs uppercase tracking-[0.2em] text-amber-500">Fält & Fakturering</div>
          </div>
        </div>

        <div className="rounded-2xl border border-slate-800 bg-slate-900/70 p-7 backdrop-blur">
          <h1 className="font-display text-2xl font-bold text-white">Logga in</h1>
          <p className="mb-6 mt-1 text-sm text-slate-400">Rapportera tid, maskiner och material.</p>
          <form onSubmit={submit} className="space-y-4">
            <div>
              <Label>E-post</Label>
              <Input data-testid="login-email-input" type="email" value={email}
                onChange={(e) => setEmail(e.target.value)} placeholder="namn@tjekab.se" required />
            </div>
            <div>
              <Label>Lösenord</Label>
              <Input data-testid="login-password-input" type="password" value={password}
                onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" required />
            </div>
            <Button data-testid="login-submit-button" type="submit" disabled={busy} className="w-full">
              {busy ? "Loggar in…" : <>Logga in <ArrowRight size={16} /></>}
            </Button>
          </form>
          <button type="button" data-testid="forgot-password-link" onClick={forgot}
            className="mt-4 text-xs text-slate-400 transition-colors hover:text-amber-400">
            Glömt lösenord?
          </button>
        </div>
      </div>
    </div>
  );
}
